module.exports = __webpack_public_path__ + "static/media/trash-can_white.97351ea3.svg";